import { State, Action, SaveStatus } from "./smart-formatting-settings.types";

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "SET_INSTRUCTIONS":
      return {
        ...state,
        currentInstructions: action.value,
        error: action.error,
        saveStatus: state.saveStatus === SaveStatus.Saved ? SaveStatus.Idle : state.saveStatus,
      };
    case "SET_ENABLED":
      return {
        ...state,
        isEnabled: action.isEnabled,
        isEditing: true,
        saveStatus: state.saveStatus === SaveStatus.Saved ? SaveStatus.Idle : state.saveStatus,
      };
    case "START_SAVING":
      return { ...state, saveStatus: SaveStatus.Saving };
    case "SAVE_SUCCESS":
      return {
        ...state,
        currentInstructions: action.instructions,
        originalInstructions: action.instructions,
        isEnabled: action.isEnabled,
        originalIsEnabled: action.isEnabled,
        saveStatus: SaveStatus.Saved,
        isEditing: false,
        isResetting: true,
      };
    case "SAVE_ERROR":
      return { ...state, error: action.error, saveStatus: SaveStatus.Idle };
    case "CANCEL":
      return {
        ...state,
        currentInstructions: state.originalInstructions,
        isEnabled: state.originalIsEnabled,
        error: null,
        saveStatus: SaveStatus.Idle,
        isEditing: false,
        isResetting: true,
      };
    case "START_EDITING":
      return { ...state, isEditing: true };
    case "CLEAR_RESETTING":
      return { ...state, isResetting: false };
    default:
      return state;
  }
}
